import { usePermissionsContext } from '../contexts/PermissionsContext';

export default function usePermissions() {
    return usePermissionsContext();
}
